import { IAttributeFilterState, IFilter, ICustomFilter, IRootState } from '@/store/types/IRootState';
import FilterServiceBase from '@/services/FilterServiceBase';
import { isNameFilter } from '@/store/isNameFilter';

const attributeFilterGetters = {
    getAttributeFilters: (state: IRootState): IAttributeFilterState[] => {
        return state.attributeFilters;
    },
    getCustomAttributeFilters: (state: any): ICustomFilter => {
        return state.attributeFilters.map((attributeFilter: IAttributeFilterState) => attributeFilter.customFilter)
            .filter((currentCustomFilter: ICustomFilter) => currentCustomFilter.value !== '');
    },
    getAttributeTitle(state: IRootState, attrib: string): string {
        return attrib;
    },
    getNAttributeFilters: (state: any) => (attributeFilterName: string, numberFiltersToShow: number): IFilter[] => {
        if (attributeFilterName) {
            const attributeFilter = state.attributeFilters
                .find((currentAttributeFilter: IAttributeFilterState) => currentAttributeFilter.name === attributeFilterName);

            return FilterServiceBase.getters.getNFilters(
                attributeFilter.filters,
                numberFiltersToShow,
                attributeFilter.showAllFilters);
        }
        return [];
    },
    getNumberOfRemainingAttributeFilters: (state: any) => (attributeFilterName: string, numberFiltersToShow: number): number => {
        if (attributeFilterName) {
            return state.attributeFilters
                .find((attributeFilter: IAttributeFilterState) => attributeFilter.name === attributeFilterName)
                .filters.length - numberFiltersToShow;
        }
        return 0;
    },
    getCheckedAttributeFilters: (state: IRootState): IFilter[] => {
        return state.attributeFilters
            .map((attributeFilter: IAttributeFilterState) =>
                attributeFilter.filters.filter(
                    (currentFilter: any) => currentFilter.checked === true,
                ),
            )
            .reduce(
                (previousValues: any, current: any) => previousValues.concat(current),
                [],
            );
    },
    getShowAllAttributeFiltersFlag: (state: any) => (attributeFilterName: string): boolean => {
        return state.attributeFilters.find((attributeFilter: IAttributeFilterState) => attributeFilter.name === attributeFilterName)
            .showAllFilters;
    },
    getShowFilterGroupAttributeFiltersFlag: (state: any) => (attributeFilterName: string): boolean => {
        return state.attributeFilters.find((attributeFilter: IAttributeFilterState) => attributeFilter.name === attributeFilterName)
            .showFilterGroup;
    },
    hasAttributeFilters(state: IRootState): boolean {
        return state.attributeFilters.length > 0;
    },
    displayAttributeFilter: (state: IRootState) => (attributeFilter: IAttributeFilterState): boolean => {
        return isNameFilter(attributeFilter.name) ||
               !(attributeFilter.filters.length === 1 && attributeFilter.filters[0].count === state.itemsCounter);
    },
};

export default attributeFilterGetters;
